/** The URL only when it is http(s). Draft data reaches the admin from a
 * model and from WordPress, so a `javascript:` or `data:` URL must never
 * become an href or an image src. */
export function safeHref(u: string | null | undefined): string | undefined {
  if (!u) return undefined
  return /^https?:\/\//i.test(u) ? u : undefined
}

export function escapeHtml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}
